/**
 * Country SEO i18n - Wave 2
 * Expands language coverage for existing countries that only had 1-3 languages
 * Adds remaining 15 language translations for maximum SERP dominance
 */

import type { CountrySEOMap } from './country-seo-i18n-types';

export const COUNTRY_SEO_I18N_WAVE2: CountrySEOMap = {

  // ============ Expand GERMANY to more languages ============
  germany: {
    it: {
      title: 'Call Center Germania | Assistenza Clienti in Tedesco | Call IT Dev',
      description: 'Call center per la Germania: agenti germanofoni, CSAT 95%, da 10 €/h. 55% risparmio vs Berlino.',
      heroTitle: 'Call Center per la Germania — Supporto in Tedesco',
      heroSubtitle: 'Assistenza clienti premium in tedesco a prezzi nearshore.',
    },
    pt: {
      title: 'Call Center Alemanha | Atendimento ao Cliente em Alemão | Call IT Dev',
      description: 'Call center para Alemanha: agentes germanófonos, CSAT 95%, a partir de 10 €/h. 55% economia vs Berlim.',
      heroTitle: 'Call Center para Alemanha — Suporte em Alemão',
      heroSubtitle: 'Atendimento premium em alemão a preços nearshore.',
    },
    nl: {
      title: 'Callcenter Duitsland | Duitstalige Klantenservice | Call IT Dev',
      description: 'Callcenter voor Duitsland: Duitstalige agenten, CSAT 95%, vanaf 10 €/u. 55% besparing vs Berlijn.',
      heroTitle: 'Callcenter voor Duitsland — Duitstalige Klantenservice',
      heroSubtitle: 'Premium klantenservice in het Duits tegen nearshore-prijzen.',
    },
    pl: {
      title: 'Call Center Niemcy | Outsourcing Obsługi Klienta | Call IT Dev',
      description: 'Call center dla Niemiec: agenci niemieckojęzyczni, CSAT 95%, od 10 €/h. 55% oszczędności vs Berlin.',
      heroTitle: 'Call Center dla Niemiec — Obsługa po Niemiecku',
      heroSubtitle: 'Premium obsługa klienta po niemiecku w cenach nearshore.',
    },
    ru: {
      title: 'Колл-центр Германия | Аутсорсинг обслуживания 24/7 | Call IT Dev',
      description: 'Колл-центр для Германии: немецкоговорящие агенты, CSAT 95%, от 10 €/ч. 55% экономия vs Берлин.',
      heroTitle: 'Колл-центр для Германии — Немецкоязычная поддержка',
      heroSubtitle: 'Премиум-обслуживание на немецком по nearshore-ценам.',
    },
    zh: {
      title: '德国呼叫中心 | 德语客服外包 24/7 | Call IT Dev',
      description: '德国呼叫中心外包：德语母语座席，CSAT 95%，10€/小时起。比柏林节省55%。',
      heroTitle: '德国呼叫中心 — 德语母语客服支持',
      heroSubtitle: '以nearshore价格提供优质德语客户体验。',
    },
    ja: {
      title: 'ドイツコールセンター | ドイツ語カスタマーサポート外注 | Call IT Dev',
      description: 'ドイツ向けコールセンター外注：ドイツ語ネイティブ、CSAT 95%、10€/時間〜。ベルリン比55%削減。',
      heroTitle: 'ドイツ向けコールセンター — ドイツ語ネイティブサポート',
      heroSubtitle: 'ニアショア価格でプレミアムなドイツ語顧客体験を。',
    },
    ko: {
      title: '독일 콜센터 | 독일어 고객 서비스 아웃소싱 | Call IT Dev',
      description: '독일 콜센터 아웃소싱: 독일어 원어민 상담원, CSAT 95%, 시간당 10유로부터. 베를린 대비 55% 절감.',
      heroTitle: '독일 콜센터 — 독일어 원어민 지원',
      heroSubtitle: '니어쇼어 가격으로 프리미엄 독일어 고객 경험.',
    },
    tr: {
      title: 'Almanya Çağrı Merkezi | Almanca Müşteri Hizmetleri | Call IT Dev',
      description: 'Almanya için çağrı merkezi: Almanca konuşan acenteler, CSAT %95, 10 €/saatten.',
      heroTitle: 'Almanya İçin Çağrı Merkezi — Almanca Müşteri Desteği',
      heroSubtitle: 'Nearshore fiyatlarla premium Almanca müşteri deneyimi.',
    },
    sv: {
      title: 'Callcenter Tyskland | Tyskspråkig Kundtjänst | Call IT Dev',
      description: 'Callcenter för Tyskland: tysktalande agenter, CSAT 95%, från 10 €/h. 55% besparing vs Berlin.',
      heroTitle: 'Callcenter för Tyskland — Tyskspråkig Kundtjänst',
      heroSubtitle: 'Premium kundtjänst på tyska till nearshore-priser.',
    },
    da: {
      title: 'Callcenter Tyskland | Tysktalende Kundeservice | Call IT Dev',
      description: 'Callcenter til Tyskland: tysktalende agenter, CSAT 95%, fra 10 €/t. 55% besparelse vs Berlin.',
      heroTitle: 'Callcenter til Tyskland — Tysktalende Kundeservice',
      heroSubtitle: 'Premium kundeservice på tysk til nearshore-priser.',
    },
  },

  // ============ Expand SPAIN to more languages ============
  spain: {
    nl: {
      title: 'Callcenter Spanje | Spaanstalige Klantenservice | Call IT Dev',
      description: 'Callcenter voor Spanje: Spaanstalige agenten, CSAT 95%, vanaf 3 $/u. 55% besparing vs Madrid.',
      heroTitle: 'Callcenter voor Spanje — Spaanstalige Klantenservice',
      heroSubtitle: 'Premium klantenservice in het Spaans tegen nearshore-prijzen.',
    },
    pl: {
      title: 'Call Center Hiszpania | Outsourcing Obsługi Klienta | Call IT Dev',
      description: 'Call center dla Hiszpanii: agenci hiszpańskojęzyczni, CSAT 95%, od 3 $/h. 55% oszczędności vs Madryt.',
      heroTitle: 'Call Center dla Hiszpanii — Obsługa po Hiszpańsku',
      heroSubtitle: 'Premium obsługa klienta po hiszpańsku w cenach nearshore.',
    },
    ru: {
      title: 'Колл-центр Испания | Испаноязычная поддержка 24/7 | Call IT Dev',
      description: 'Колл-центр для Испании: испаноговорящие агенты, CSAT 95%, от 3 $/ч. 55% экономия vs Мадрид.',
      heroTitle: 'Колл-центр для Испании — Испаноязычная поддержка',
      heroSubtitle: 'Премиум-обслуживание на испанском.',
    },
    zh: {
      title: '西班牙呼叫中心 | 西班牙语客服外包 | Call IT Dev',
      description: '西班牙呼叫中心外包：西班牙语母语座席，CSAT 95%，3美元/小时起。比马德里节省55%。',
      heroTitle: '西班牙呼叫中心 — 西班牙语母语支持',
      heroSubtitle: '以nearshore价格提供优质西班牙语客户体验。',
    },
    ja: {
      title: 'スペインコールセンター | スペイン語サポート外注 | Call IT Dev',
      description: 'スペイン向けコールセンター：スペイン語ネイティブ、CSAT 95%、3$/時間〜。マドリード比55%削減。',
      heroTitle: 'スペイン向けコールセンター — スペイン語サポート',
      heroSubtitle: 'ニアショア価格でプレミアムなスペイン語体験。',
    },
    ko: {
      title: '스페인 콜센터 | 스페인어 고객 서비스 | Call IT Dev',
      description: '스페인 콜센터: 스페인어 원어민 상담원, CSAT 95%, 시간당 3달러부터. 마드리드 대비 55% 절감.',
      heroTitle: '스페인 콜센터 — 스페인어 원어민 지원',
      heroSubtitle: '니어쇼어 가격으로 프리미엄 스페인어 경험.',
    },
    tr: {
      title: 'İspanya Çağrı Merkezi | İspanyolca Müşteri Hizmetleri | Call IT Dev',
      description: 'İspanya için çağrı merkezi: İspanyolca konuşan acenteler, CSAT %95, 3 $/saatten.',
      heroTitle: 'İspanya İçin Çağrı Merkezi — İspanyolca Destek',
      heroSubtitle: 'Nearshore fiyatlarla premium İspanyolca müşteri deneyimi.',
    },
    sv: {
      title: 'Callcenter Spanien | Spansktalande Kundtjänst | Call IT Dev',
      description: 'Callcenter för Spanien: spansktalande agenter, CSAT 95%, från 3 $/h. 55% besparing vs Madrid.',
      heroTitle: 'Callcenter för Spanien — Spansktalande Kundtjänst',
      heroSubtitle: 'Premium kundtjänst på spanska till nearshore-priser.',
    },
    da: {
      title: 'Callcenter Spanien | Spansktalende Kundeservice | Call IT Dev',
      description: 'Callcenter til Spanien: spansktalende agenter, CSAT 95%, fra 3 $/t. 55% besparelse vs Madrid.',
      heroTitle: 'Callcenter til Spanien — Spansktalende Kundeservice',
      heroSubtitle: 'Premium kundeservice på spansk til nearshore-priser.',
    },
  },

  // ============ Expand UK to more languages ============
  uk: {
    it: {
      title: 'Call Center Regno Unito | Assistenza Clienti in Inglese | Call IT Dev',
      description: 'Call center per il Regno Unito: agenti anglofoni, CSAT 95%, da 3 $/h. 65% risparmio vs Londra.',
      heroTitle: 'Call Center per il Regno Unito — Supporto in Inglese',
      heroSubtitle: 'Assistenza clienti premium in inglese a prezzi nearshore.',
    },
    pt: {
      title: 'Call Center Reino Unido | Atendimento em Inglês | Call IT Dev',
      description: 'Call center para Reino Unido: agentes anglófonos, CSAT 95%, a partir de 3 $/h. 65% economia vs Londres.',
      heroTitle: 'Call Center para Reino Unido — Suporte em Inglês',
      heroSubtitle: 'Atendimento premium em inglês a preços nearshore.',
    },
    nl: {
      title: 'Callcenter Verenigd Koninkrijk | Engelstalige Klantenservice | Call IT Dev',
      description: 'Callcenter voor VK: Engelstalige agenten, CSAT 95%, vanaf 3 $/u. 65% besparing vs Londen.',
      heroTitle: 'Callcenter voor het VK — Engelstalige Klantenservice',
      heroSubtitle: 'Premium klantenservice in het Engels.',
    },
    pl: {
      title: 'Call Center Wielka Brytania | Outsourcing Obsługi po Angielsku | Call IT Dev',
      description: 'Call center dla Wielkiej Brytanii: agenci anglojęzyczni, CSAT 95%, od 3 $/h. 65% oszczędności vs Londyn.',
      heroTitle: 'Call Center dla Wielkiej Brytanii — Obsługa po Angielsku',
      heroSubtitle: 'Premium obsługa klienta po angielsku.',
    },
    ru: {
      title: 'Колл-центр Великобритания | Англоязычная поддержка 24/7 | Call IT Dev',
      description: 'Колл-центр для Великобритании: англоговорящие агенты, CSAT 95%, от 3 $/ч. 65% экономия vs Лондон.',
      heroTitle: 'Колл-центр для Великобритании — Англоязычная поддержка',
      heroSubtitle: 'Премиум-обслуживание на английском.',
    },
    zh: {
      title: '英国呼叫中心 | 英语客服外包 24/7 | Call IT Dev',
      description: '英国呼叫中心外包：英语母语座席，CSAT 95%，3美元/小时起。比伦敦节省65%。',
      heroTitle: '英国呼叫中心 — 英语母语支持',
      heroSubtitle: '以nearshore价格提供优质英语客户体验。',
    },
    ja: {
      title: 'イギリスコールセンター | 英語カスタマーサポート外注 | Call IT Dev',
      description: 'イギリス向けコールセンター：英語ネイティブ、CSAT 95%、3$/時間〜。ロンドン比65%削減。',
      heroTitle: 'イギリス向けコールセンター — 英語ネイティブサポート',
      heroSubtitle: 'ニアショア価格でプレミアムな英語体験。',
    },
    ko: {
      title: '영국 콜센터 | 영어 고객 서비스 아웃소싱 | Call IT Dev',
      description: '영국 콜센터: 영어 원어민 상담원, CSAT 95%, 시간당 3달러부터. 런던 대비 65% 절감.',
      heroTitle: '영국 콜센터 — 영어 원어민 지원',
      heroSubtitle: '니어쇼어 가격으로 프리미엄 영어 경험.',
    },
    tr: {
      title: 'Birleşik Krallık Çağrı Merkezi | İngilizce Müşteri Hizmetleri | Call IT Dev',
      description: 'BK için çağrı merkezi: İngilizce konuşan acenteler, CSAT %95, 3 $/saatten.',
      heroTitle: 'Birleşik Krallık İçin Çağrı Merkezi — İngilizce Destek',
      heroSubtitle: 'Nearshore fiyatlarla premium İngilizce müşteri deneyimi.',
    },
    sv: {
      title: 'Callcenter Storbritannien | Engelsktalande Kundtjänst | Call IT Dev',
      description: 'Callcenter för Storbritannien: engelsktalande agenter, CSAT 95%, från 3 $/h. 65% besparing vs London.',
      heroTitle: 'Callcenter för Storbritannien — Engelsktalande Kundtjänst',
      heroSubtitle: 'Premium kundtjänst på engelska.',
    },
    da: {
      title: 'Callcenter Storbritannien | Engelsktalende Kundeservice | Call IT Dev',
      description: 'Callcenter til Storbritannien: engelsktalende agenter, CSAT 95%, fra 3 $/t. 65% besparelse vs London.',
      heroTitle: 'Callcenter til Storbritannien — Engelsktalende Kundeservice',
      heroSubtitle: 'Premium kundeservice på engelsk.',
    },
  },

  // ============ Expand USA to more languages ============
  usa: {
    it: {
      title: 'Call Center USA | Assistenza Clienti 24/7 | Call IT Dev',
      description: 'Call center per gli USA: agenti bilingui inglese/spagnolo, CSAT 95%, da 3 $/h. 70% risparmio vs New York.',
      heroTitle: 'Call Center per gli USA — Supporto Bilingue 24/7',
      heroSubtitle: 'Assistenza clienti premium per il mercato americano.',
    },
    pt: {
      title: 'Call Center EUA | Atendimento ao Cliente 24/7 | Call IT Dev',
      description: 'Call center para EUA: agentes bilingues inglês/espanhol, CSAT 95%, a partir de 3 $/h. 70% economia.',
      heroTitle: 'Call Center para EUA — Suporte Bilingue 24/7',
      heroSubtitle: 'Atendimento premium para o mercado americano.',
    },
    nl: {
      title: 'Callcenter VS | Klantenservice 24/7 | Call IT Dev',
      description: 'Callcenter voor VS: tweetalige agenten Engels/Spaans, CSAT 95%, vanaf 3 $/u. 70% besparing.',
      heroTitle: 'Callcenter voor de VS — Tweetalige Klantenservice',
      heroSubtitle: 'Premium klantenservice voor de Amerikaanse markt.',
    },
    pl: {
      title: 'Call Center USA | Obsługa Klienta 24/7 | Call IT Dev',
      description: 'Call center dla USA: dwujęzyczni agenci angielski/hiszpański, CSAT 95%, od 3 $/h. 70% oszczędności.',
      heroTitle: 'Call Center dla USA — Dwujęzyczna Obsługa 24/7',
      heroSubtitle: 'Premium obsługa klienta dla rynku amerykańskiego.',
    },
    ru: {
      title: 'Колл-центр США | Двуязычная поддержка 24/7 | Call IT Dev',
      description: 'Колл-центр для США: двуязычные агенты англ/исп, CSAT 95%, от 3 $/ч. 70% экономия.',
      heroTitle: 'Колл-центр для США — Двуязычная поддержка 24/7',
      heroSubtitle: 'Премиум-обслуживание для американского рынка.',
    },
    zh: {
      title: '美国呼叫中心 | 双语客服外包 24/7 | Call IT Dev',
      description: '美国呼叫中心外包：英西双语座席，CSAT 95%，3美元/小时起。比纽约节省70%。',
      heroTitle: '美国呼叫中心 — 双语客服支持 24/7',
      heroSubtitle: '为美国市场提供优质双语客户体验。',
    },
    ja: {
      title: 'アメリカコールセンター | バイリンガルサポート 24/7 | Call IT Dev',
      description: 'アメリカ向けコールセンター：英語/スペイン語バイリンガル、CSAT 95%、3$/時間〜。NY比70%削減。',
      heroTitle: 'アメリカ向けコールセンター — バイリンガルサポート',
      heroSubtitle: '米国市場向けプレミアム顧客体験。',
    },
    ko: {
      title: '미국 콜센터 | 이중 언어 고객 서비스 24/7 | Call IT Dev',
      description: '미국 콜센터: 영어/스페인어 이중 언어 상담원, CSAT 95%, 시간당 3달러부터. 뉴욕 대비 70% 절감.',
      heroTitle: '미국 콜센터 — 이중 언어 지원 24/7',
      heroSubtitle: '미국 시장을 위한 프리미엄 경험.',
    },
    tr: {
      title: 'ABD Çağrı Merkezi | İki Dilli Müşteri Hizmetleri 24/7 | Call IT Dev',
      description: 'ABD için çağrı merkezi: İngilizce/İspanyolca iki dilli acenteler, CSAT %95, 3 $/saatten.',
      heroTitle: 'ABD İçin Çağrı Merkezi — İki Dilli Destek 24/7',
      heroSubtitle: 'Amerikan pazarı için premium müşteri deneyimi.',
    },
    sv: {
      title: 'Callcenter USA | Tvåspråkig Kundtjänst 24/7 | Call IT Dev',
      description: 'Callcenter för USA: tvåspråkiga agenter engelska/spanska, CSAT 95%, från 3 $/h. 70% besparing.',
      heroTitle: 'Callcenter för USA — Tvåspråkig Kundtjänst 24/7',
      heroSubtitle: 'Premium kundtjänst för den amerikanska marknaden.',
    },
    da: {
      title: 'Callcenter USA | Tosproget Kundeservice 24/7 | Call IT Dev',
      description: 'Callcenter til USA: tosprogede agenter engelsk/spansk, CSAT 95%, fra 3 $/t. 70% besparelse.',
      heroTitle: 'Callcenter til USA — Tosproget Kundeservice 24/7',
      heroSubtitle: 'Premium kundeservice for det amerikanske marked.',
    },
  },

  // ============ Expand UAE to more languages ============
  uae: {
    it: {
      title: 'Call Center EAU Dubai | Assistenza Multilingue | Call IT Dev',
      description: 'Call center per EAU: agenti arabofoni e anglofoni, CSAT 95%, da 3 $/h. Supporto 24/7.',
      heroTitle: 'Call Center per gli EAU — Supporto Multilingue',
      heroSubtitle: 'Assistenza clienti premium per il mercato emiratino.',
    },
    pt: {
      title: 'Call Center EAU Dubai | Atendimento Multilingue | Call IT Dev',
      description: 'Call center para EAU: agentes árabes e ingleses, CSAT 95%, a partir de 3 $/h.',
      heroTitle: 'Call Center para EAU — Suporte Multilingue',
      heroSubtitle: 'Atendimento premium para o mercado emiradense.',
    },
    nl: {
      title: 'Callcenter VAE Dubai | Meertalige Klantenservice | Call IT Dev',
      description: 'Callcenter voor VAE: Arabisch- en Engelstalige agenten, CSAT 95%, vanaf 3 $/u.',
      heroTitle: 'Callcenter voor de VAE — Meertalige Klantenservice',
      heroSubtitle: 'Premium klantenservice voor de Emiratische markt.',
    },
    ru: {
      title: 'Колл-центр ОАЭ Дубай | Многоязычная поддержка | Call IT Dev',
      description: 'Колл-центр для ОАЭ: арабо- и англоговорящие агенты, CSAT 95%, от 3 $/ч.',
      heroTitle: 'Колл-центр для ОАЭ — Многоязычная поддержка',
      heroSubtitle: 'Премиум-обслуживание для рынка Эмиратов.',
    },
    zh: {
      title: '阿联酋迪拜呼叫中心 | 多语种客服 | Call IT Dev',
      description: '阿联酋呼叫中心：阿拉伯语和英语座席，CSAT 95%，3美元/小时起。24/7支持。',
      heroTitle: '阿联酋呼叫中心 — 多语种客服支持',
      heroSubtitle: '为阿联酋市场提供优质多语种客户体验。',
    },
    ja: {
      title: 'UAEドバイコールセンター | 多言語カスタマーサポート | Call IT Dev',
      description: 'UAE向けコールセンター：アラビア語/英語対応、CSAT 95%、3$/時間〜。24/7サポート。',
      heroTitle: 'UAE向けコールセンター — 多言語サポート',
      heroSubtitle: 'UAE市場向けプレミアム多言語体験。',
    },
    ko: {
      title: 'UAE 두바이 콜센터 | 다국어 고객 서비스 | Call IT Dev',
      description: 'UAE 콜센터: 아랍어/영어 상담원, CSAT 95%, 시간당 3달러부터. 24/7 지원.',
      heroTitle: 'UAE 콜센터 — 다국어 고객 지원',
      heroSubtitle: 'UAE 시장을 위한 프리미엄 다국어 경험.',
    },
    tr: {
      title: 'BAE Dubai Çağrı Merkezi | Çok Dilli Müşteri Hizmetleri | Call IT Dev',
      description: 'BAE için çağrı merkezi: Arapça ve İngilizce konuşan acenteler, CSAT %95, 3 $/saatten.',
      heroTitle: 'BAE İçin Çağrı Merkezi — Çok Dilli Destek',
      heroSubtitle: 'Emirat pazarı için premium müşteri deneyimi.',
    },
    sv: {
      title: 'Callcenter Förenade Arabemiraten Dubai | Flerspråkig Kundtjänst | Call IT Dev',
      description: 'Callcenter för FAE: arabisk- och engelsktalande agenter, CSAT 95%, från 3 $/h.',
      heroTitle: 'Callcenter för FAE — Flerspråkig Kundtjänst',
      heroSubtitle: 'Premium kundtjänst för emiratiska marknaden.',
    },
    da: {
      title: 'Callcenter De Forenede Arabiske Emirater | Flersproget Kundeservice | Call IT Dev',
      description: 'Callcenter til FAE: arabisk- og engelsktalende agenter, CSAT 95%, fra 3 $/t.',
      heroTitle: 'Callcenter til FAE — Flersproget Kundeservice',
      heroSubtitle: 'Premium kundeservice for det emiratiske marked.',
    },
    pl: {
      title: 'Call Center ZEA Dubaj | Wielojęzyczna Obsługa | Call IT Dev',
      description: 'Call center dla ZEA: agenci arabsko- i anglojęzyczni, CSAT 95%, od 3 $/h.',
      heroTitle: 'Call Center dla ZEA — Wielojęzyczna Obsługa',
      heroSubtitle: 'Premium obsługa klienta dla rynku emiratów.',
    },
  },

  // ============ Expand CANADA to more languages ============
  canada: {
    de: {
      title: 'Call Center Kanada | Zweisprachiger Kundenservice FR/EN | Call IT Dev',
      description: 'Call Center für Kanada: zweisprachige Agenten FR/EN, CSAT 95%, ab 3 $/h. 65% Ersparnis vs Montreal.',
      heroTitle: 'Call Center für Kanada — Zweisprachiger Support FR/EN',
      heroSubtitle: 'Zweisprachiger Kundenservice für den kanadischen Markt.',
    },
    ar: {
      title: 'مركز اتصال كندا | خدمة عملاء ثنائية اللغة | Call IT Dev',
      description: 'مركز اتصال لكندا: وكلاء ثنائيو اللغة فرنسي/إنجليزي، CSAT 95%، من 3 $/ساعة.',
      heroTitle: 'مركز اتصال لكندا — دعم ثنائي اللغة',
      heroSubtitle: 'خدمة عملاء ثنائية اللغة للسوق الكندي.',
    },
    pt: {
      title: 'Call Center Canadá | Atendimento Bilingue FR/EN | Call IT Dev',
      description: 'Call center para Canadá: agentes bilíngues francês/inglês, CSAT 95%, a partir de 3 $/h.',
      heroTitle: 'Call Center para Canadá — Suporte Bilingue FR/EN',
      heroSubtitle: 'Atendimento bilíngue para o mercado canadense.',
    },
    zh: {
      title: '加拿大呼叫中心 | 双语客服 FR/EN | Call IT Dev',
      description: '加拿大呼叫中心：法英双语座席，CSAT 95%，3美元/小时起。比蒙特利尔节省65%。',
      heroTitle: '加拿大呼叫中心 — 双语客服支持',
      heroSubtitle: '为加拿大市场提供双语客户体验。',
    },
    ja: {
      title: 'カナダコールセンター | バイリンガルサポート FR/EN | Call IT Dev',
      description: 'カナダ向けコールセンター：仏英バイリンガル、CSAT 95%、3$/時間〜。モントリオール比65%削減。',
      heroTitle: 'カナダ向けコールセンター — バイリンガルサポート',
      heroSubtitle: 'カナダ市場向けバイリンガル体験。',
    },
    ko: {
      title: '캐나다 콜센터 | 이중 언어 고객 서비스 FR/EN | Call IT Dev',
      description: '캐나다 콜센터: 불어/영어 이중 언어 상담원, CSAT 95%, 시간당 3달러부터.',
      heroTitle: '캐나다 콜센터 — 이중 언어 지원',
      heroSubtitle: '캐나다 시장을 위한 이중 언어 경험.',
    },
  },

  // ============ Expand ITALY to more languages ============
  italy: {
    de: {
      title: 'Call Center Italien | Italienischsprachiger Kundenservice | Call IT Dev',
      description: 'Call Center für Italien: italienischsprachige Agenten, CSAT 95%, ab 3 $/h. 55% Ersparnis vs Mailand.',
      heroTitle: 'Call Center für Italien — Italienischsprachiger Support',
      heroSubtitle: 'Premium-Kundenservice auf Italienisch.',
    },
    es: {
      title: 'Call Center Italia | Atención al Cliente en Italiano | Call IT Dev',
      description: 'Call center para Italia: agentes italófonos, CSAT 95%, desde 3 $/h. 55% ahorro vs Milán.',
      heroTitle: 'Call Center para Italia — Soporte en Italiano',
      heroSubtitle: 'Atención al cliente premium en italiano.',
    },
    pt: {
      title: 'Call Center Itália | Atendimento em Italiano | Call IT Dev',
      description: 'Call center para Itália: agentes italófonos, CSAT 95%, a partir de 3 $/h. 55% economia vs Milão.',
      heroTitle: 'Call Center para Itália — Suporte em Italiano',
      heroSubtitle: 'Atendimento premium em italiano.',
    },
    ar: {
      title: 'مركز اتصال إيطاليا | خدمة عملاء بالإيطالية | Call IT Dev',
      description: 'مركز اتصال لإيطاليا: وكلاء ناطقون بالإيطالية، CSAT 95%، من 3 $/ساعة. توفير 55%.',
      heroTitle: 'مركز اتصال لإيطاليا — دعم بالإيطالية',
      heroSubtitle: 'خدمة عملاء متميزة بالإيطالية.',
    },
    zh: {
      title: '意大利呼叫中心 | 意大利语客服外包 | Call IT Dev',
      description: '意大利呼叫中心外包：意大利语座席，CSAT 95%，3美元/小时起。比米兰节省55%。',
      heroTitle: '意大利呼叫中心 — 意大利语支持',
      heroSubtitle: '以nearshore价格提供优质意大利语体验。',
    },
    ja: {
      title: 'イタリアコールセンター | イタリア語サポート外注 | Call IT Dev',
      description: 'イタリア向けコールセンター：イタリア語対応、CSAT 95%、3$/時間〜。ミラノ比55%削減。',
      heroTitle: 'イタリア向けコールセンター — イタリア語サポート',
      heroSubtitle: 'ニアショア価格でプレミアムなイタリア語体験。',
    },
    ko: {
      title: '이탈리아 콜센터 | 이탈리아어 고객 서비스 | Call IT Dev',
      description: '이탈리아 콜센터: 이탈리아어 상담원, CSAT 95%, 시간당 3달러부터. 밀라노 대비 55% 절감.',
      heroTitle: '이탈리아 콜센터 — 이탈리아어 지원',
      heroSubtitle: '니어쇼어 가격으로 이탈리아어 경험.',
    },
  },

  // ============ Expand NETHERLANDS to more languages ============
  netherlands: {
    de: {
      title: 'Callcenter Niederlande | Niederländischsprachiger Kundenservice | Call IT Dev',
      description: 'Callcenter für Niederlande: mehrsprachige Agenten, CSAT 95%, ab 3 $/h. 55% Ersparnis vs Amsterdam.',
      heroTitle: 'Callcenter für die Niederlande — Mehrsprachiger Kundenservice',
      heroSubtitle: 'Premium-Kundenservice für den niederländischen Markt.',
    },
    es: {
      title: 'Call Center Países Bajos | Atención al Cliente Multilingüe | Call IT Dev',
      description: 'Call center para Países Bajos: agentes multilingües, CSAT 95%, desde 3 $/h. 55% ahorro vs Ámsterdam.',
      heroTitle: 'Call Center para Países Bajos — Soporte Multilingüe',
      heroSubtitle: 'Atención al cliente premium para el mercado holandés.',
    },
    ar: {
      title: 'مركز اتصال هولندا | خدمة عملاء متعددة اللغات | Call IT Dev',
      description: 'مركز اتصال لهولندا: وكلاء متعددو اللغات، CSAT 95%، من 3 $/ساعة. توفير 55%.',
      heroTitle: 'مركز اتصال لهولندا — دعم متعدد اللغات',
      heroSubtitle: 'خدمة عملاء متميزة للسوق الهولندي.',
    },
    zh: {
      title: '荷兰呼叫中心 | 多语种客服外包 | Call IT Dev',
      description: '荷兰呼叫中心外包：多语种座席，CSAT 95%，3美元/小时起。比阿姆斯特丹节省55%。',
      heroTitle: '荷兰呼叫中心 — 多语种客服支持',
      heroSubtitle: '为荷兰市场提供优质多语种体验。',
    },
    ja: {
      title: 'オランダコールセンター | 多言語サポート外注 | Call IT Dev',
      description: 'オランダ向けコールセンター：多言語対応、CSAT 95%、3$/時間〜。55%削減。',
      heroTitle: 'オランダ向けコールセンター — 多言語サポート',
      heroSubtitle: 'オランダ市場向けプレミアム多言語体験。',
    },
  },

  // ============ Expand BELGIUM to more languages ============
  belgium: {
    es: {
      title: 'Call Center Bélgica | Atención Trilingüe FR/NL/DE | Call IT Dev',
      description: 'Call center para Bélgica: agentes trilingües FR/NL/DE, CSAT 95%, desde 3 $/h. 55% ahorro vs Bruselas.',
      heroTitle: 'Call Center para Bélgica — Soporte Trilingüe',
      heroSubtitle: 'Atención trilingüe para el mercado belga.',
    },
    ar: {
      title: 'مركز اتصال بلجيكا | خدمة ثلاثية اللغات FR/NL/DE | Call IT Dev',
      description: 'مركز اتصال لبلجيكا: وكلاء ثلاثيو اللغة، CSAT 95%، من 3 $/ساعة. توفير 55%.',
      heroTitle: 'مركز اتصال لبلجيكا — دعم ثلاثي اللغات',
      heroSubtitle: 'خدمة عملاء ثلاثية اللغات للسوق البلجيكي.',
    },
    it: {
      title: 'Call Center Belgio | Assistenza Trilingue FR/NL/DE | Call IT Dev',
      description: 'Call center per il Belgio: agenti trilingui FR/NL/DE, CSAT 95%, da 3 $/h. 55% risparmio vs Bruxelles.',
      heroTitle: 'Call Center per il Belgio — Assistenza Trilingue',
      heroSubtitle: 'Assistenza trilingue per il mercato belga.',
    },
  },

  // ============ Expand SWITZERLAND to more languages ============
  switzerland: {
    es: {
      title: 'Call Center Suiza | Atención Trilingüe FR/DE/IT | Call IT Dev',
      description: 'Call center para Suiza: agentes trilingües FR/DE/IT, CSAT 95%, desde 8 €/h. 60% ahorro vs Zúrich.',
      heroTitle: 'Call Center para Suiza — Soporte Trilingüe',
      heroSubtitle: 'Atención trilingüe para el mercado suizo.',
    },
    ar: {
      title: 'مركز اتصال سويسرا | خدمة ثلاثية اللغات FR/DE/IT | Call IT Dev',
      description: 'مركز اتصال لسويسرا: وكلاء ثلاثيو اللغة FR/DE/IT، CSAT 95%، من 8 €/ساعة. توفير 60%.',
      heroTitle: 'مركز اتصال لسويسرا — دعم ثلاثي اللغات',
      heroSubtitle: 'خدمة ثلاثية اللغات للسوق السويسري.',
    },
    pt: {
      title: 'Call Center Suíça | Atendimento Trilingue FR/DE/IT | Call IT Dev',
      description: 'Call center para Suíça: agentes trilingues FR/DE/IT, CSAT 95%, a partir de 8 €/h. 60% economia.',
      heroTitle: 'Call Center para Suíça — Suporte Trilingue',
      heroSubtitle: 'Atendimento trilingue para o mercado suíço.',
    },
  },

  // ============ Expand BRAZIL to more languages ============
  brazil: {
    de: {
      title: 'Call Center Brasilien | Portugiesischsprachiger Kundenservice | Call IT Dev',
      description: 'Call Center für Brasilien: portugiesischsprachige Agenten, CSAT 95%, ab 3 $/h. 60% Ersparnis vs São Paulo.',
      heroTitle: 'Call Center für Brasilien — Portugiesischsprachiger Support',
      heroSubtitle: 'Premium-Kundenservice auf Portugiesisch für den brasilianischen Markt.',
    },
    ar: {
      title: 'مركز اتصال البرازيل | خدمة عملاء بالبرتغالية | Call IT Dev',
      description: 'مركز اتصال للبرازيل: وكلاء ناطقون بالبرتغالية، CSAT 95%، من 3 $/ساعة. توفير 60%.',
      heroTitle: 'مركز اتصال للبرازيل — دعم بالبرتغالية',
      heroSubtitle: 'خدمة عملاء متميزة بالبرتغالية للسوق البرازيلي.',
    },
    zh: {
      title: '巴西呼叫中心 | 葡萄牙语客服外包 | Call IT Dev',
      description: '巴西呼叫中心外包：葡萄牙语座席，CSAT 95%，3美元/小时起。比圣保罗节省60%。',
      heroTitle: '巴西呼叫中心 — 葡萄牙语客服支持',
      heroSubtitle: '为巴西市场提供优质葡萄牙语体验。',
    },
  },
};
